import React from "react";
import styled from "styled-components";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import ViewSelector from "./view.selector";
import Row from "./row";
import { makeStyles } from "@material-ui/core/styles";
import { useStudyPlan } from "../../../../../app/contexts/study.context";
import { Title } from "../../../../../app/components";
import SeparateContainer from "../../../../../app/components/separate.Container";
import SideBySide from "../../../../../app/components/sideBySide";

const rowsData = [
  { name: "Active Sites", key: "active_sites" },
  { name: "Participants Screened", key: "screened" },
  { name: "Participants Enrolled", key: "enrolled" },
  { name: "Participants Completing Treatment", key: "completed" },
];

export default function DetailsTable({ view, setView, type, ...props }) {
  const rowClasses = useRowStyles();
  const headerClasses = useHeaderStyles();
  const cellHeaderClasses = useCellHeaderStyles();
  const { simulationResults } = useStudyPlan();
  const {
    detailsByWeek,
    detailsByWeekNonCumulative,
    detailsByMonth,
    detailsByMonthNonCumulative,
    detailsByWeekCohort,
    detailsByWeekNonCumulativeCohort,
    detailsByMonthCohort,
    detailsByMonthNonCumulativeCohort,
  } = simulationResults;

  let data = {
    monthly: type === "cohort" ? detailsByMonthCohort : detailsByMonth,
    weekly: type === "cohort" ? detailsByWeekCohort : detailsByWeek,
    monthlyNonCumulative:
      type === "cohort"
        ? detailsByMonthNonCumulativeCohort
        : detailsByMonthNonCumulative,
    weeklyNonCumulative:
      type === "cohort"
        ? detailsByWeekNonCumulativeCohort
        : detailsByWeekNonCumulative,
  };

  if (!data[view]) {
    return null;
  }

  const subTableLength = (data[view].header_dates?.length || 0) + 1;

  return (
    <SeparateContainer style={{ marginTop: "1.5em" }}>
      {
        <ControlsContainer>
          {props.extraControls &&
            React.cloneElement(props.extraControls, { detailsView: view })}
        </ControlsContainer>
      }
      <SideBySide>
        <Title
          size="medium"
          dense
        >
          {type === "cohort" ? "Details - Cohort" : "Details"}
        </Title>
      </SideBySide>

      <TableContainer component={Paper}>
        <Table aria-label="collapsible table">
          <TableHead classes={rowClasses}>
            <TableRow style={{ height: "112px" }}>
              <TableCell classes={cellHeaderClasses}></TableCell>
              {data[view].header_dates?.map((date) => (
                <TableCell
                  key={date}
                  align="right"
                  classes={headerClasses}
                >
                  {date}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rowsData.map(({ name, key }) => (
              <Row
                key={key}
                name={name}
                row={data[view]?.table_body?.[key]}
                subTableLength={subTableLength}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <ViewSelector
        type={type}
        value={view}
        onChange={(view) => setView(view)}
      />
    </SeparateContainer>
  );
}

const useRowStyles = makeStyles((theme) => ({
  root: {
    background: "var(--surface-100)",
  },
}));

const useHeaderStyles = makeStyles(() => ({
  root: {
    fontWeight: 600,
    textAlign: "center",
    whiteSpace: "nowrap",
    transformOrigin: "50% 50%",
    transform: "rotate(270deg)",
    padding: "5px",
    width: "80px",
    minWidth: "80px",
    maxWidth: "80px",
    height: "8rem",
  },
}));

const useCellHeaderStyles = makeStyles(() => ({
  root: {
    width: "201px",
    position: "sticky",
    left: 0,
    zIndex: 1,
    height: "67px",
    backgroundColor: "var(--surface-100)",
  },
}));

const ControlsContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;
